import { FeedbackType, IFeedbackCreate } from "@/api";
import { Stack, ToggleButton } from "@mui/material";
import { useFormContext } from "react-hook-form";

/**
 * Toggle buttons for feedback types
 */
export const FeedbackTypes = () => {
    const { watch, setValue } = useFormContext<IFeedbackCreate>();
    return (
        <Stack
            direction={"row"}
            gap={1}
            flexWrap={"wrap"}
            justifyContent={"flex-start"}
        >
            {Object.entries(FeedbackType).map(([key, value]) => (
                <ToggleButton
                    key={key}
                    value={value}
                    selected={watch("feedback_type") === value}
                    onClick={() => setValue("feedback_type", value)}
                    sx={{
                        textTransform: "capitalize",
                        p: 0.5,
                        borderRadius: 2,
                        borderColor: "#666666",
                        fontSize: 12,
                    }}
                >
                    {value}
                </ToggleButton>
            ))}
        </Stack>
    );
};
